/* Paths */

export const getTaxPayer = (cuit) => {
  return `/v1/person/holder/${cuit}`;
};

export const getContribitor = (cuit) => {
  return `/v1/person/contributor/${cuit}`;
};
